export default "__VITE_ASSET__DHbnJLvV__"